import type { FaireProductEntity } from "../../entity_types/product";

export const p_7gxxwh45jk: FaireProductEntity = {
  token: "p_7gxxwh45jk",
  type: "product",
  name: "Knit Cardigan (branded)",
  brandToken: "b_6d9w5m3rqy",
  brandName: "land of petite",
  imageUrl:
    "https://cdn.faire.com/fastly/f7fe4904d2c632ba728fca83709c12ecdac0b2bb7e665b69a37b1ee77c9034f2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0d5c0d776b0dda05e7c24be17df3b7ea6bde9ec31a1ce131d59ef86667de5c17.jpeg",
    "https://cdn.faire.com/fastly/3d0c6e623a9bea488c43c145b464b6ac3b192898d09640af038791ad9ff5bd27.jpeg",
    "https://cdn.faire.com/fastly/f17aa193f9430a9726993140552855b1974610c993b5df50bb3a38e69dc1eecf.jpeg",
    "https://cdn.faire.com/fastly/10b28ac0470dcf1900e08ab70be1d8471f6090584627238a3e9207b5ee31b392.png",
    "https://cdn.faire.com/fastly/d534cea4406d2ddd19f7f5441f8c3e1e6bcf57416d8331ac41944c90653a5281.png",
    "https://cdn.faire.com/fastly/88a273ea373838f2bc76c1a96a20bd770aad7f9246f988c5cfa14530073b3fa1.png",
  ],
  priceDollars: 13.95,
  description:
    "Keep your little one warm and cozy with this adorable cotton long-sleeve knit cardigan. Designed in three beautiful neutral tones — Cream, Blush, and Oatmeal — it pairs effortlessly with any everyday outfit.\n\nSoft, comfortable, and perfect for layering season after season.\n\nAvailable Colors: Cream, Blush, Oatmeal\nAvailable Sizes: 6–12 months, 12–18 months\n\nA timeless wardrobe essential for your baby’s closet!",
  tags: [],
  msrpDollars: 27.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:36.252Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
